import { EnvService } from '../environments/environmentsService';

export const ENDPOINTS_SEGMENTS: Dict<string> = {
  TENANT_ID: '{tenantId}',
  FORM_DEF_ID: '{formDefId}',
  FORM_SESSION_TOKEN: '{formSessionToken}',
  FORM_ORGANISATION_SESSION_TOKEN: '{organisationFormSessionToken}',
  FILE_UPLOAD_DIRNAME: '{dirName}',
  TASK_ID: '{taskId}',
  PRINT_LAYOUT_ID: '{printLayoutId}',
  FORM_PROJECT_ID: '{projectId}',
};

const {
  FORMS_API_URL,
  ISSUANCE_API_URL,
  APP_USER_API_URL,
  ACCREDITATION_API_URL,
  APP_HUB_API_URL,
} = EnvService.getInstance();

const FORMS_SERVICE_ENDPOINTS: Dict<string> = {
  SAVE_STEP_FORM: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}/save`,
  SUBMIT_FORM: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}/submit`,
  CREATE_FORM_SESSION: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/`,
  GET_FORM_DEFINITION: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formdefs/${ENDPOINTS_SEGMENTS.FORM_DEF_ID}`,
  GET_FORM_SESSION: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}`,
  GET_PREVIEW_MOCKED_DATA: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formpreview`,
  GET_PROJECT_IMAGE_RULES: `${FORMS_API_URL}/enduser/projects/image-rules`,
  CREATE_FORM_SESSION_FROM_ORGANISATION: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/organisationFormSessionToken/${ENDPOINTS_SEGMENTS.FORM_ORGANISATION_SESSION_TOKEN}`,
  // CREATE_FORM_SESSION_FROM_GENERIC_REGISTRATION: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/project/${ENDPOINTS_SEGMENTS.FORM_PROJECT_ID}/formDefId/${ENDPOINTS_SEGMENTS.FORM_DEF_ID}`, // Old url
  CREATE_FORM_SESSION_FROM_GENERIC_REGISTRATION: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/createFormSession`,

  GET_EVENTS: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}/events`,
  GET_GERMAN_STATES: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}/states`,
  GET_COUNTRIES_LIST_WITH_ALLOWED_STATES: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/stateselectcountries`,
  CREATE_ACCOUNT: `${FORMS_API_URL}/enduser/accounts`,
  EMAIL_OTP_VALIDATION: `${FORMS_API_URL}/enduser/accounts/validateEmailOTP`,
  GET_ATTRACTION_SLOTS: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}/availableattractionSlots`,
  MY_FORMS: `${FORMS_API_URL}/user/forms`,
  GET_DISABILITIES_CATEGORIES: `${FORMS_API_URL}/enduser/disability/categories`,
  VALIDATE_FORM_SESSION_TOKEN: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/validateFormSessionToken/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}`,
  FORM_SESSION_IMAGE_PREVIEW: `${FORMS_API_URL}/enduser/tenants/${ENDPOINTS_SEGMENTS.TENANT_ID}/formsessions/${ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN}/preview`,
  DOWNLOAD_SECURE_FILE: `${APP_HUB_API_URL}/downloadsecurefiles`,
};

const AGENDA_SERVICE_ENDPOINTS: Dict<string> = {
  FILE_UPLOAD_API: `${FORMS_API_URL}/enduser/ext/dir/${ENDPOINTS_SEGMENTS.FILE_UPLOAD_DIRNAME}/files`,
};

const ISSUANCE_SERVICE_ENDPOINTS: Dict<string> = {
  GET_PDF_RESOURCE_LOCATION: `${ISSUANCE_API_URL}/queue/task/${ENDPOINTS_SEGMENTS.TASK_ID}`,
  GET_PDF_INSTRUCTIONS: `${ISSUANCE_API_URL}/asyncexport/credential?printLayoutId=${ENDPOINTS_SEGMENTS.PRINT_LAYOUT_ID}`,
  GET_COUNTRY_STATES: `${ISSUANCE_API_URL}/loadStates`,
};

export const APP_USER_SERVICE_ENDPOINTS: Dict<string> = {
  USER_LOGIN: `${APP_USER_API_URL}/auth/login/v2`,
  RESEND_OTP: `${APP_USER_API_URL}/users/verifyEmail`,
  FORGOT_PASSWORD: `${APP_USER_API_URL}/auth/forgotPass`,
  VALIDATE_FORGOT_PASSWORD: `${APP_USER_API_URL}/auth/validateForgotPass`,
  UPDATE_PASSWORD: `${APP_USER_API_URL}/users/updatePassword`,
};

export const ACCREDITATION_SERVICE_ENDPOINTS: Dict<string> = {
  MY_REQUESTS: `${ACCREDITATION_API_URL}/enduser-accounts/requests/all`,
  MY_REQUESTS_DETAILS: `${ACCREDITATION_API_URL}/enduser-accounts/request/:requestId`,
  DOWNLOAD_TICKET: `${ACCREDITATION_API_URL}/enduser-accounts/:requestId/downloadTicket`,
  GET_PDF_RESOURCE_LOCATION: `${ACCREDITATION_API_URL}/queue/task/${ENDPOINTS_SEGMENTS.TASK_ID}`,
  UPDATE_REQUEST: `${ACCREDITATION_API_URL}/enduser-accounts/:requestId/update`,

  ACCOUNTS: `${ACCREDITATION_API_URL}/enduser-accounts`,
};

const ENDPOINTS: Dict<string> = {
  ...FORMS_SERVICE_ENDPOINTS,
  ...AGENDA_SERVICE_ENDPOINTS,
  ...ISSUANCE_SERVICE_ENDPOINTS,
};

export default ENDPOINTS;
